import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import DownloadCTA from './components/DownloadCTA';
import Support from './components/Support';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import { backgroundImage } from './assets/images';

// Main content component
const MainContent: React.FC = () => {
  return (
    <>
      <div className="relative z-10">
        <section id="hero" className="py-8">
          <Hero />
        </section>
        
        <section id="features" className="py-8">
          <Features />
        </section>
        
        <section id="download" className="py-8">
          <DownloadCTA />
        </section>
        
        <section id="support" className="py-8 mb-20">
          <Support />
        </section>
      </div>
      
      <Footer />
    </>
  );
};

const PrivacyPage: React.FC = () => {
  // Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative z-10 pt-20 pb-32 min-h-screen">
      <PrivacyPolicy />
      <div className="text-center mt-8 mb-20">
        <Link 
          to="/"
          className="bg-white/20 backdrop-blur-sm border border-white/30 text-white px-6 py-2 rounded-md hover:bg-white/30 transition-colors inline-block"
        >
          Back to Main Page
        </Link>
      </div>
    </div>
  );
};

// Layout wrapper component
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen w-full">
      {/* Background Image */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat w-full h-full"
        style={{ 
          backgroundImage: `url(${backgroundImage})`,
          filter: 'brightness(0.6)'
        }}
      ></div>
      
      {/* Black overlay for better visibility */}
      <div className="fixed inset-0 bg-black bg-opacity-60 w-full h-full"></div>
      <Header />
      
      {children}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Layout>
            <MainContent />
          </Layout>
        } />
        <Route path="/privacy" element={
          <Layout>
            <PrivacyPage />
          </Layout>
        } />
      </Routes>
    </Router>
  );
};

export default App; 